var map = {
	"./Example.js": 6550,
	"./HowToSpotWinningProductsOnWalmartBeforeEveryoneElse.js": 6361,
	"./HowToUseHistoricalDataAsAWalmartSeller.js": 4761,
	"./HowToUsePriceTrackersAsAWalmartSeller5ProvenStrategiesFor2025.js": 2011,
	"./HowToWinTheByBoxOnWalmartIn2025WithRealData.js": 2055,
	"./KeepaForWalmart.js": 4945,
	"./TheUltimateSoftwareSuiteForWalmartSellers.js": 8328,
	"./Top3WalmartPriceTrackingToolsForSellers.js": 7076,
	"./Top5WalmartPriceTrackersCompared.js": 4252,
	"./WalmartPriceTrackerThatWorksin2025.js": 3659,
	"./WalmartProductResearch2025HistoricalData.js": 6846,
	"./index.js": 8771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6962;